import React, { Fragment } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles,
} from "@material-ui/core";

import { Title } from "../../component";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: 42,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& th": {
      fontWeight: "bold",
    },
    "& td": {
      borderBottom: 0,
    },
  },
}));

const Activities = ({ record, resource, indexWp }) => {
  const translate = useTranslate();
  const classes = useStyles();
  return (
    <Table className={classes.root}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={5}>
            <Title resource={resource} />
          </TableCell>
        </TableRow>

        {record.length !== 0 && (
          <TableRow>
            <TableCell>
              {translate(`resources.${resource}.fields.number`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.description`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.start_month`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.duration`)}
            </TableCell>
            <TableCell>
              {translate(`resources.${resource}.fields.venue_types`)}
            </TableCell>
          </TableRow>
        )}
      </TableHead>
      <TableBody>
        {record.length !== 0 ? (
          record?.map((activity, index) => {
            return (
              <Fragment key={index}>
                <TableRow>
                  <TableCell>
                    {indexWp}.{activity?.index}
                  </TableCell>
                  <TableCell>{activity?.description}</TableCell>
                  <TableCell>{activity?.start_month}</TableCell>
                  <TableCell>{activity?.duration}</TableCell>
                  <TableCell>{activity?.venue_type?.name}</TableCell>
                </TableRow>
              </Fragment>
            );
          })
        ) : (
          <TableRow>
            <TableCell>
              {translate(`resources.${resource}.fields.empty`)}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
export default Activities;
